import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Trading Performance")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_popover = _resolveComponent("ion-popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_button, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setOpen(true, $event))),
      expand: "block"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_ion_popover, {
      "is-open": _ctx.isOpenRef,
      event: _ctx.event,
      "css-class": "trade-popover",
      onDidDismiss: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setOpen(false)))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trades, (trade, index) => {
          return (_openBlock(), _createBlock(_component_ion_item, { key: index }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_text, {
                color: trade.profit > 0 ? 'green' : 'danger'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.type == "weekly" ? `W${index + 1}` : _ctx.monthNames[index]) + " : " + _toDisplayString(trade.profit), 1)
                ]),
                _: 2
              }, 1032, ["color"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["is-open", "event"])
  ], 64))
}